import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'complianceTable' })
export class CompliancePipe implements PipeTransform {
  /**
   * Pipe filters the list of rooms-chat based on the search text provided
   *
   * @returns return required value
   * @param complianceRule
   * @param key
   * @param index
   */
  transform(
    complianceRule: any,
    key: string,
    index: string | boolean = false
  ): string {
    const complianceRuleValue = complianceRule.find(
      (complianceRule: any) => complianceRule.start === index
    );

    if (index === 'current') {
      if (complianceRuleValue[key] === 1) {
        return '<span class="badge compliance-large-badge compliance-green-bg font-size-14"><i class="bx bxs-badge-check me-2"></i>Compliant</span>';
      } else {
        return '<h5><span class="badge compliance-large-badge compliance-red-bg font-size-14"><i class="bx bx-alarm me-2"></i>Not Compliant</span></h5>';
      }
    }

    if (complianceRuleValue[key] === 1) {
      return '<span class="text-primary font-size-20"><i class="bx bxs-badge-check"></i></span>';
    }
    if (complianceRuleValue[key] === 0) {
      return '<span class="text-danger font-size-20"><i class="bx bx-alarm"></i></span>';
    }

    return '<span class="font-size-12 gray-light-color fw-light">N/A</span>';
  }
}
